import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class ReportSalesByCategoryService {
    async getList(params: any, page: string, size: string): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.SALES_BY_CATEGORY}?size=${size}&page=${page}`, params);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }
}

const reportSalesByCategoryService = new ReportSalesByCategoryService();
export default reportSalesByCategoryService;